var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.827 7.897a.25.25 0 0 1 .072-.155L9.187.454a.25.25 0 0 1 .353 0l2.36 2.36a.25.25 0 0 1 0 .353l-7.288 7.288a.25.25 0 0 1-.155.072l-2.587.227a.25.25 0 0 1-.27-.27l.227-2.587Z",
    fill: "#E59400"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.66,
    y: 11.834,
    width: 12.042,
    height: 1.128,
    rx: 0.25,
    fill: "#E59400"
  })));
};
export default SvgEdit;